import {VALIDATE_FIELDS} from "./types";

export const setFieldsWithErrors = (payload) => {
    return {
        type: VALIDATE_FIELDS,
        payload: payload
    }
}